import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { getConnection, getErrorMessage, hideSpinner, ignoreSpecialCharacters, showSpinner } from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { arrayNotEmpty } from 'class-validator';
import { ActivatedRoute } from '@angular/router';
import { SerEndpoint } from '../../models/endpoint.model';
import { EndpointsService } from '../../services/endpoints.service';

@Component({
  selector: 'app-endpoints',
  templateUrl: './endpoints.component.html',
  styleUrls: ['./endpoints.component.scss']
})
export class EndpointsComponent implements OnInit {

  endpoints: SerEndpoint[] = []
  selectedEndpoint: SerEndpoint | undefined

  form: FormGroup
  icons: string[] = []

  constructor(
    private endpointsService: EndpointsService,
    private helpers: HelpersService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
  ) {
    this.form = this.formBuilder.group({
      id: [""],
      estado: ["", [Validators.required]],
      clave: ["", [Validators.required]],
      valor: ["", [Validators.required]],
    })
    this.resetForm()
  }

  async ngOnInit() {
    const data = this.activatedRoute.snapshot.data
    if (data.title) {
      this.helpers.setTitle(data.title);
    }
    showSpinner()
    await this.getAllEndpoints()
    hideSpinner()
  }

  resetForm(selectedEndpoint: SerEndpoint | undefined = undefined) {
    if (selectedEndpoint == undefined) {
      this.selectedEndpoint = undefined
      this.form.reset()
    } else {
      this.form.get("id")?.setValue(selectedEndpoint?.id)
      this.form.get("estado")?.setValue(selectedEndpoint?.estado)
      this.form.get("clave")?.setValue(selectedEndpoint?.clave)
      this.form.get("valor")?.setValue(selectedEndpoint?.valor)
    }
  }

  async getAllEndpoints() {
    showSpinner()
    try {
      const result = await this.endpointsService.findAll({}, true)
      if (result.success) {
        this.endpoints = result.data
      } else {
        this.helpers.notifications.errorMessage(result.message)
      }
    } catch (error) {
      const message = getErrorMessage(error)
      this.helpers.notifications.errorMessage(message)
    }
    hideSpinner()
  }

  async selectEndpoint(selected: SerEndpoint[]) {
    showSpinner()
    if (arrayNotEmpty(selected) && selected[0].clave) {
      this.selectedEndpoint = undefined
      this.selectedEndpoint = selected[0]
      this.resetForm(this.selectedEndpoint)
    }
    hideSpinner()
  }

  async create() {
    showSpinner()
    if (this.form.valid) {
      try {
        const result = await this.endpointsService.create(this.form.value)
        if (result.success) {
          await this.getAllEndpoints()
          this.helpers.notifications.successMessage(result.message)
        } else {
          this.helpers.notifications.errorMessage(result.message)
        }
        hideSpinner()
      } catch (error) {
        hideSpinner()
        const message = getErrorMessage(error)
        this.helpers.notifications.errorMessage(message)
      }
    } else {
      hideSpinner()
      this.helpers.notifications.errorMessage("Todos los campos son obligatorios")
    }
  }

  async modify() {
    showSpinner()
    if (this.form.valid && this.selectedEndpoint && this.selectedEndpoint.id) {
      try {
        const result = await this.endpointsService.update(this.form.value, {
          c_emp: getConnection(),
          id: this.selectedEndpoint?.id
        })
        if (result.success) {
          await this.selectEndpoint([{ clave: result.data.current[0].clave }])
          this.getAllEndpoints()
          this.helpers.notifications.successMessage(result.message)
        } else {
          this.helpers.notifications.errorMessage(result.message)
        }
        hideSpinner()
      } catch (error) {
        hideSpinner()
        const message = getErrorMessage(error)
        this.helpers.notifications.errorMessage(message)
      }
    } else {
      hideSpinner()
      this.helpers.notifications.errorMessage("Todos los campos son obligatorios")
    }
  }
  ignoreSpecialCharactersVoid(controlName: string, value: string) {
    let hola = ignoreSpecialCharacters(value)
    this.form.get(controlName)?.setValue(hola)
    return hola
  }
  print(value) {
    console.log(value)
    return JSON.stringify(value)
  }
}